var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnDownvote = function SvgIcnDownvote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10V3h2.333v7H13.5Zm-2.333-7a1.167 1.167 0 0 1 1.166 1.167V10c0 .32-.128.613-.344.822l-3.838 3.845-.619-.619a.868.868 0 0 1-.256-.618l.017-.18.554-2.667h-3.68A1.166 1.166 0 0 1 3 9.417V8.25c0-.152.03-.292.082-.426l1.761-4.112c.175-.42.59-.712 1.074-.712h5.25Zm0 1.167H5.899L4.167 8.25v1.167h5.121L8.63 12.52l2.538-2.537V4.167Z",
    fill: "#292525"
  })));
};
export default SvgIcnDownvote;